import React, { useState } from "react";
import avatar from "../../assets/avatar.png";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";

const MyProfile = () => {
  const [image, setImage] = useState("");
  console.log(image);
  return (
    <div className="mono_my_profile_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_my_profile_card"
      >
        <div className="mono_section_title">
          <h2>profile</h2>
        </div>
        <div className="mono_profile_head">
          <div className="mono_photo_content">
            <div className="mono_cover_photo"></div>
          </div>
          <div className="mono_profile_short_info">
            <div className="mono_profile_photo">
              <img src={avatar} width="100%" alt="img" />
              <form encType="multipart/form-data">
                <div className="form-check form-check-label">
                  <label htmlFor="img" className="form-check-label">
                    <Input
                      type="file"
                      name="file"
                      className="form-check-label"
                      onChange={(e) => setImage(e.target.value)}
                    />
                  </label>
                </div>
              </form>
            </div>
            <div className="mono_profile_info">
              <div className="mono_profile_name">
                <h2>MLM POINT</h2>
                <p>Digital Marketar</p>
              </div>
              <div className="mono_profile_email">
                <h2>support@mlmpoint.org</h2>
                <p>Email</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mono_profile_bottom">
          <div className="mono_profile_title">
            <h2>Profile Info details</h2>
          </div>
          <div className="mono_profile_field">
            <div className="user_id field_row">
              <strong>user id</strong>
              <span>mono12787</span>
            </div>
            <div className="user_id field_row">
              <strong>Name</strong>
              <span>MLM POINT</span>
            </div>
            <div className="user_id field_row">
              <strong>Gender</strong>
              <span>Male</span>
            </div>
            <div className="user_id field_row">
              <strong>TRON Address</strong>
              <span>XcdufffnchfCetXAwr</span>
            </div>
            <div className="user_id field_row">
              <strong>Phone No.</strong>
              <span>+91XXXXXXXXX</span>
            </div>
            <div className="user_id field_row">
              <strong>Country</strong>
              <span>USA</span>
            </div>
            <div className="user_id field_row">
              <strong>Referral Link Left</strong>
              <span>
                <a
                  href="http://www.mlmpoint.org"
                  target="_blank"
                  rel="noreferrer"
                >
                  http://www.mlmpoint.org
                </a>
              </span>
            </div>
            <div className="user_id field_row">
              <strong>Referral Link Right</strong>
              <span>
                <a
                  href="http://www.mlmpoint.org"
                  target="_blank"
                  rel="noreferrer"
                >
                  http://www.mlmpoint.org
                </a>
              </span>
            </div>
          </div>
        </div>
      </CardLayout>
    </div>
  );
};

export default MyProfile;
